import { __extends } from "tslib";
import { Debug, Point as APoint } from '@awayjs/core';
import { StageManager } from '@awayjs/stage';
import { SceneImage2D } from '@awayjs/scene';
import { ASObject } from '@awayfl/avm2';
var ALER_TABLE = {};
var ALERT_ONCE = function (id, message) {
    if (ALER_TABLE[id])
        return;
    console.warn("".concat(id, ":"), message);
    ALER_TABLE[id] = true;
};
var BitmapData = /** @class */ (function (_super) {
    __extends(BitmapData, _super);
    function BitmapData(width, height, transparent, fillColor) {
        if (transparent === void 0) { transparent = true; }
        if (fillColor === void 0) { fillColor = 0xffffffff; }
        var _this = _super.call(this) || this;
        _this._owners = [];
        if (typeof width === 'number') {
            if (!_this._adaptee) {
                _this._adaptee = SceneImage2D.getImage(width, height, transparent, fillColor, false, StageManager.getInstance().getStageAt(0));
                // we construct a SceneImage2D direct, use weak, that call dispose after garbaging
                _this._adaptee.useWeakRef();
            }
        }
        else {
            _this._adaptee = width;
        }
        _this._adaptee.adapter = _this;
        return _this;
    }
    // for AVM1:
    BitmapData.prototype.compare = function (other) {
        return true;
    };
    Object.defineProperty(BitmapData.prototype, "adaptee", {
        get: function () {
            return this._adaptee;
        },
        set: function (value) {
            this._adaptee = value;
        },
        enumerable: false,
        configurable: true
    });
    BitmapData.loadBitmap = function (id) {
        // @todo
        Debug.throwPIR('playerglobals/display/BitmapData', 'loadBitmap', '');
        return null;
    };
    BitmapData.prototype.setPixels = function (rect, inputByteArray) {
        // @todo
        Debug.throwPIR('playerglobals/display/BitmapData', 'setPixels', '');
    };
    BitmapData.prototype.getPixels = function (rect) {
        var buffer = this.adaptee.getPixels(rect.adaptee);
        var arr = new this.sec.flash.utils.ByteArray();
        // @ts-ignore
        arr.setArrayBuffer(buffer.buffer);
        //console.log('getPixels not implemented yet in flash/BitmapData');
        return arr;
    };
    BitmapData.prototype.copyPixelsToByteArray = function (rect, data) {
        // @todo
        Debug.throwPIR('playerglobals/display/BitmapData', 'copyPixelsToByteArray', '');
    };
    BitmapData.prototype.getVector = function (rect) {
        var u8 = this.adaptee.getPixels(rect.adaptee);
        // construct small buffer
        var vector = new this.sec.Uint32Vector(0, true);
        var u32 = new Uint32Array(u8.buffer);
        // flash use ARGB view, we have ABGR and PMA
        for (var i = 0; i < u32.length; i++) {
            var a = u8[i * 4 + 3];
            var r = u8[i * 4 + 0];
            var g = u8[i * 4 + 1];
            var b = u8[i * 4 + 2];
            var factor = (a / 0xff) || 1;
            u32[i] =
                (a << 24) |
                    ((r / factor) << 16) |
                    ((g / factor) << 8) |
                    (b / factor);
        }
        // replace a buffer for avoid coping
        //@ts-ignore
        vector._buffer = u32;
        // remap size
        //@ts-ignore
        vector._length = u32.length;
        return vector;
    };
    BitmapData.prototype.setVector = function (rect, inputVector) {
        // @todo
        Debug.throwPIR('playerglobals/display/BitmapData', 'setVector', '');
    };
    BitmapData.prototype.histogram = function (hRect) {
        if (hRect === void 0) { hRect = null; }
        // @todo
        Debug.throwPIR('playerglobals/display/BitmapData', 'histogram', '');
        return;
    };
    BitmapData.prototype.encode = function (rect, compressor, byteArray) {
        if (byteArray === void 0) { byteArray = null; }
        // @todo
        Debug.throwPIR('playerglobals/display/BitmapData', 'encode', '');
        return;
    };
    BitmapData.prototype.drawWithQuality = function (source, matrix, colorTransform, blendMode, clipRect, smoothing, quality) {
        if (matrix === void 0) { matrix = null; }
        if (colorTransform === void 0) { colorTransform = null; }
        if (blendMode === void 0) { blendMode = null; }
        if (clipRect === void 0) { clipRect = null; }
        if (smoothing === void 0) { smoothing = false; }
        if (quality === void 0) { quality = null; }
        this._adaptee.draw(source.adaptee, matrix === null || matrix === void 0 ? void 0 : matrix.adaptee, colorTransform === null || colorTransform === void 0 ? void 0 : colorTransform.adaptee, blendMode, clipRect === null || clipRect === void 0 ? void 0 : clipRect.adaptee, smoothing);
    };
    Object.defineProperty(BitmapData.prototype, "transparent", {
        get: function () {
            return this._adaptee.transparent;
        },
        set: function (value) {
            this._adaptee.transparent = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapData.prototype, "width", {
        get: function () {
            return this._adaptee.width;
        },
        set: function (value) {
            this._adaptee.width = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BitmapData.prototype, "height", {
        get: function () {
            return this._adaptee.height;
        },
        set: function (value) {
            this._adaptee.height = value;
        },
        enumerable: false,
        configurable: true
    });
    BitmapData.prototype.clone = function () {
        var clone = new this.sec.flash.display.BitmapData(this._adaptee.width, this._adaptee.height, this._adaptee.transparent, null);
        // refclone
        if (this._adaptee.copyTo) {
            this._adaptee.copyTo(clone._adaptee);
        }
        else {
            clone.copyPixels(this, this.rect, new this.sec.flash.geom.Point());
        }
        return clone;
    };
    Object.defineProperty(BitmapData.prototype, "rect", {
        get: function () {
            return new this.sec.flash.geom.Rectangle(this._adaptee.rect.clone());
        },
        enumerable: false,
        configurable: true
    });
    BitmapData.prototype.getPixel = function (x, y) {
        return this._adaptee.getPixel(x, y);
    };
    BitmapData.prototype.getPixel32 = function (x, y) {
        return this._adaptee.getPixel32(x, y);
    };
    BitmapData.prototype.setPixel = function (x, y, color) {
        this._adaptee.setPixel(x, y, color);
    };
    BitmapData.prototype.setPixel32 = function (x, y, color) {
        this._adaptee.setPixel32(x, y, color);
    };
    BitmapData.prototype.applyFilter = function (sourceBitmap, sourceRect, destPoint, filter) {
        if (this._adaptee.applyFilter(sourceBitmap.adaptee, sourceRect.adaptee, destPoint.adaptee, filter.toAwayObject())) {
            return;
        }
        Debug.throwPIR('playerglobals/display/BitmapData', 'applyFilter', filter.axClassName);
    };
    BitmapData.prototype.colorTransform = function (rect, colorTransform) {
        this._adaptee.colorTransform(rect.adaptee, colorTransform.adaptee);
    };
    BitmapData.prototype.copyChannel = function (sourceBitmap, sourceRect, destPoint, sourceChannel, destChannel) {
        this._adaptee.copyChannel(sourceBitmap.adaptee, sourceRect.adaptee, destPoint.adaptee, sourceChannel, destChannel);
    };
    BitmapData.prototype.copyPixels = function (sourceBitmap, sourceRect, destPoint, alphaBitmapData, alphaPoint, mergeAlpha) {
        if (alphaBitmapData === void 0) { alphaBitmapData = null; }
        if (alphaPoint === void 0) { alphaPoint = null; }
        if (mergeAlpha === void 0) { mergeAlpha = false; }
        this._adaptee.copyPixels(sourceBitmap.adaptee, sourceRect.adaptee, destPoint.adaptee, alphaBitmapData ? alphaBitmapData.adaptee : null, alphaPoint ? alphaPoint.adaptee : null, mergeAlpha);
    };
    BitmapData.prototype.dispose = function () {
        // already disposed or not setted
        if (!this._adaptee)
            return;
        //remove all owners
        this._owners = [];
        if (this._adaptee.canUnload) {
            this._adaptee.dispose();
        }
        this._adaptee = null;
    };
    BitmapData.prototype.draw = function (source, matrix, colorTransform, blendMode, clipRect, smoothing) {
        if (colorTransform === void 0) { colorTransform = null; }
        if (blendMode === void 0) { blendMode = ''; }
        if (clipRect === void 0) { clipRect = null; }
        if (smoothing === void 0) { smoothing = false; }
        this._adaptee.draw(source.adaptee, matrix === null || matrix === void 0 ? void 0 : matrix.adaptee, colorTransform === null || colorTransform === void 0 ? void 0 : colorTransform.adaptee, blendMode, clipRect === null || clipRect === void 0 ? void 0 : clipRect.adaptee, smoothing);
    };
    BitmapData.prototype.fillRect = function (rect, color) {
        // var colorArr = ColorUtils.float32ColorToARGB(color);
        // color = ColorUtils.ARGBtoFloat32(colorArr[0], colorArr[3], colorArr[2], colorArr[1]);
        this._adaptee.fillRect(rect.adaptee, color);
    };
    BitmapData.prototype.floodFill = function (x, y, color) {
        ALERT_ONCE('floodFill:' + this._adaptee.id, 'Unsage implementation!');
        this._adaptee.floodFill(x, y, color);
    };
    BitmapData.prototype.generateFilterRect = function (sourceRect, filter) {
        Debug.throwPIR('playerglobals/display/BitmapData', 'generateFilterRect', '');
        return null;
    };
    BitmapData.prototype.getColorBoundsRect = function (mask, color, findColor) {
        Debug.throwPIR('playerglobals/display/BitmapData', 'getColorBoundsRect', '');
        return new this.sec.flash.geom.Rectangle(this._adaptee.getColorBoundsRect(mask, color, findColor));
    };
    BitmapData.prototype.hitTest = function (firstPoint, firstAlphaThreshold, secondObject, secondBitmapPoint, secondAlphaThreshold) {
        if (secondAlphaThreshold === void 0) { secondAlphaThreshold = 0; }
        Debug.throwPIR('playerglobals/display/BitmapData', 'hitTest', '');
        return this._adaptee.hitTest(firstPoint.adaptee, firstAlphaThreshold, secondObject === null || secondObject === void 0 ? void 0 : secondObject.adaptee, secondBitmapPoint === null || secondBitmapPoint === void 0 ? void 0 : secondBitmapPoint.adaptee, secondAlphaThreshold);
    };
    BitmapData.prototype.lock = function () {
        this._adaptee.lock();
    };
    BitmapData.prototype.merge = function (sourceBitmap, sourceRect, destPoint, redMult, greenMult, blueMult, alphaMult) {
        this._adaptee.merge(sourceBitmap.adaptee, sourceBitmap.rect.adaptee, destPoint.adaptee, redMult, greenMult, blueMult, alphaMult);
    };
    BitmapData.prototype.noise = function (randomSeed, low, high, channelOptions, grayScale) {
        this._adaptee.noise(randomSeed, low, high, channelOptions, grayScale);
    };
    BitmapData.prototype.paletteMap = function (sourceBitmap, sourceRect, destPoint, redArray, greenArray, blueArray, alphaArray) {
        Debug.throwPIR('playerglobals/display/BitmapData', 'paletteMap', '');
    };
    BitmapData.prototype.perlinNoise = function (baseX, baseY, numOctaves, randomSeed, stitch, fractalNoise, channelOptions, grayScale, offsets) {
        if (offsets === void 0) { offsets = null; }
        var map_offsets = offsets ? [] : null;
        if (offsets) {
            var value = offsets.value;
            var len = value.length;
            // this is VERY strange, some games use [1, 1] and then push Point to offsets, map to [x, y, x, y]
            for (var i = 0; i < len; i++) {
                if (typeof value[i] === 'number') {
                    map_offsets.push(value[i]);
                }
                else if (typeof value[i].x === 'number') {
                    map_offsets.push(value[i].x, value[i].y);
                }
            }
        }
        //@ts-ignore
        this._adaptee.perlinNoise(baseX, baseY, numOctaves, randomSeed, stitch, fractalNoise, channelOptions, grayScale, map_offsets);
        Debug.throwPIR('playerglobals/display/BitmapData', 'perlinNoise', 'Unsafe implementation, results not equal!');
    };
    BitmapData.prototype.pixelDissolve = function (sourceBitmap, sourceRect, destPoint, randomSeed, numberOfPixels, fillColor) {
        Debug.throwPIR('playerglobals/display/BitmapData', 'pixelDissolve', '');
        return 0;
    };
    BitmapData.prototype.scroll = function (x, y) {
        x = x | 0;
        y = y | 0;
        // 0, 0 scroll - is not scroll
        if (!x && !y)
            return;
        this._adaptee.copyPixels(this._adaptee, this._adaptee.rect, new APoint(x, y), null, null, false);
        //console.log('scroll not implemented yet in flash/BitmapData');
    };
    BitmapData.prototype.threshold = function (sourceBitmap, sourceRect, destPoint, operation, threshold, color, mask, copySource) {
        this._adaptee.threshold(sourceBitmap.adaptee, sourceRect.adaptee, destPoint.adaptee, operation, threshold, color, mask, copySource);
        return 0; //number of pixels is not implemented
    };
    BitmapData.prototype.unlock = function () {
        this._adaptee.unlock();
    };
    BitmapData.prototype._addOwner = function (owner) {
        //if (this._owners.indexOf(owner) == -1) this._owners.push(owner);
    };
    BitmapData.prototype._removeOwner = function (owner) {
        // const index: number = this._owners.indexOf(owner);
        // if (index != -1) {
        // 	this._owners.splice(index, 1);
        // 	if (this._owners.length === 0)
        // 		this._adaptee.clear();
        // }
    };
    return BitmapData;
}(ASObject));
export { BitmapData };
